import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BuyerService } from '../../buyer/services/buyer.service';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPackageDetailResolver implements Resolve<any> {
  private readonly logger = inject(NGXLogger);

  constructor(
    private subscriptionService: SubscriptionService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.subscriptionService.getSubscriptionPackages().pipe(
      tap((response) => {
        this.logger.debug(`SubscriptionPackageDetailResolver response is ${JSON.stringify(response)}`)
      }),
      catchError((error) => {
        this.logger.error(`SubscriptionPackageDetailResolver error is ${JSON.stringify(error)}`);
        this.router.navigate(['/error']); // Redirect on error
        return of(null);
      })
    );
  }
}
